import { Box, styled } from "@mui/material";

export const MenuContainer = styled(Box)`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: end;
  right: 0;
  top: 0;
  margin: 8px;
`;
